window.jQuery = window.$ = require('jquery');
var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('./components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/smoothScroll'));
    processInclude(require('./components/strikethrough'));
    processInclude(require('./components/wakeLock'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./components/selectCustom'));
});

require('./thirdParty/bootstrap');
require('./components/spinner');
require('bootstrap-select/js/bootstrap-select');



// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/main.js